const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
const TIMEOUT_SEC = 7;
const RES_PER_PAGE = 10;
const API_KEY = "2014899b-55ca-4b4b-ad17-2d36202647d5"
const MODAL_CLOSE_SEC = 2;

export { API_URL, TIMEOUT_SEC, RES_PER_PAGE, API_KEY, MODAL_CLOSE_SEC }
